module.exports = __webpack_public_path__ + "img/img-yida-s1.724ae7d9.png";